import { Controller } from "@hotwired/stimulus"

// Downloads a file through fetch so an error answer (e.g. 403) is shown next to
// the button instead of being saved by the browser as an HTML file.
export default class extends Controller {
  static targets = ["error"]
  static values = { forbiddenMessage: String, failedMessage: String }

  async download(event) {
    event.preventDefault()
    if (this.busy) return
    this.busy = true
    this.hideError()

    try {
      const response = await fetch(this.element.querySelector("a").href, { credentials: "same-origin" })
      const contentType = response.headers.get("Content-Type") || ""

      if (response.status === 403) {
        this.showError(this.forbiddenMessageValue)
      } else if (!response.ok || contentType.includes("text/html")) {
        this.showError(this.failedMessageValue)
      } else {
        this.save(await response.blob(), this.filenameFrom(response))
      }
    } catch {
      this.showError(this.failedMessageValue)
    } finally {
      this.busy = false
    }
  }

  save(blob, filename) {
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
    setTimeout(() => URL.revokeObjectURL(url), 1000)
  }

  filenameFrom(response) {
    const disposition = response.headers.get("Content-Disposition") || ""
    const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)
    if (encoded) return decodeURIComponent(encoded[1])
    const plain = disposition.match(/filename="?([^";]+)"?/i)
    return plain ? plain[1] : "document.pdf"
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("hidden")
  }

  hideError() {
    this.errorTarget.classList.add("hidden")
  }
}
